// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze

export default function deepFreeze(object) {
  const propNames = Object.getOwnPropertyNames(object);

  for (const name of propNames) {
    const value = object[name];

    object[name] = value && typeof value === 'object' ?
      deepFreeze(value) : value;
  }

  return Object.freeze(object);
}
